import React, { useEffect } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { TangibilitySection } from '../components/TangibilitySection';
import { SocialProofAuthorityBox } from '../components/SocialProofAuthorityBox';
import { SocialProofSection } from '../components/SocialProofSection';
import { SuccessInsert } from '../components/SuccessInsert';
import { ConnectionInsert } from '../components/ConnectionInsert';
import { ValueSummaryTable } from '../components/ValueSummaryTable';
import { BundleSection } from '../components/BundleSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { EmpathySection } from '../components/EmpathySection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { DecisionSection } from '../components/DecisionSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { StickyButton } from '../components/StickyButton';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-charcoal relative overflow-x-hidden" data-id="element-347">
      <AnnouncementBar data-id="element-348" />
      <HeroSection data-id="element-349" />
      <TangibilitySection data-id="element-350" />
      <SocialProofAuthorityBox data-id="element-351" />
      <SocialProofSection data-id="element-352" />
      <SuccessInsert data-id="element-353" />
      <ConnectionInsert data-id="element-354" />
      <ValueSummaryTable data-id="element-355" />
      <BundleSection data-id="element-356" />
      <TestimonialsSection data-id="element-357" />
      <EmpathySection data-id="element-358" />
      <OrderBumpSection data-id="element-359" />
      <DecisionSection data-id="element-360" />
      <FAQSection data-id="element-361" />
      <Footer data-id="element-362" />
      <StickyButton data-id="element-363" />
    </main>;
}